import styled from 'styled-components';

import { Button } from 'components/Button';

export const ClampRoot = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ClampBox = styled.div<{ $expanded: boolean; $lines: number; $whiteSpace: string }>`
  display: ${({ $expanded }) => ($expanded ? 'block' : '-webkit-box')};
  -webkit-line-clamp: ${({ $expanded, $lines }) => ($expanded ? 'unset' : String($lines))};
  -webkit-box-orient: vertical;
  overflow: ${({ $expanded }) => ($expanded ? 'visible' : 'hidden')};
  text-overflow: ${({ $expanded }) => ($expanded ? 'unset' : 'ellipsis')};
  overflow-wrap: anywhere;
  font-size: 14px;
  white-space: ${({ $whiteSpace }) => $whiteSpace};
`;

export const ClampToggle = styled(Button)`
  && {
    padding: 0;
    min-width: auto;
  }
`;
